<template>
  <div class="Circles">
    <canvas></canvas>
    <template v-if="initialized">
      <Base :ref="'base_'+ i" v-for="(color, i) in channel" :channel="color" :key="i" :indice="i" />
    </template>
  </div>
</template>

<script>

import gsap from "gsap"
import Base from './Base.vue'

export default {

  name: 'Circles',
  components: { Base },
  data: ()=>({
    c: null,
    ctx: null,
    tick: null,
    ready: false,
    initialized: false,
    completed: 0,
    channel: [ 'green', 'yellow', 'red', 'purple', 'blue' ],
    // channel: ['purple', 'green'],
    max: 0
  }),

  created() {
    this.max = this.channel.length
  },

  mounted() {
    this.init()
  },

  methods:{

    /*=============================================
    Utility
    =============================================*/

    rand( min, max ) {
      return Math.random() * ( max - min ) + min
    },
    normalizeFromCenter( val, max ) {
      return ( max - Math.abs( max - ( val * 2 ) ) ) / max
    },

    /*=============================================
    Scene
    =============================================*/

    isReady() {
      this.completed += 1
      if(this.completed == this.max)
        gsap.delayedCall(1, ()=>{ requestAnimationFrame( this.loop ) })
    },

    init() {

      this.c = document.querySelector( 'canvas' )    
      this.ctx = this.c.getContext( '2d' )
      this.w = window.innerWidth
      this.h = window.innerHeight
      this.c.width = this.w
      this.c.height = this.h
      this.ctx.lineWidth = 3
      this.ctx.globalCompositeOperation = 'lighter'
      this.tick = 0
      this.initialized = true
    },

    
    step() {

      for(let i=0; i<this.max; i++) 
        // console.log(this.$refs['base_'+ i][0].step);
        this.$refs['base_'+ i][0].step()
      this.tick++
    },

    draw() {

      this.ctx.clearRect( 0, 0, this.w, this.h )
      this.ctx.save()
      this.ctx.translate( this.w / 2, this.h / 2 )

      this.scale = 0.9 + Math.sin( this.tick * .01 ) * 0.1
      // this.scale = 1
      this.ctx.scale( this.scale, this.scale )

      this.ctx.rotate( this.tick * .01 ) 
      this.ctx.rotate( this.tick * 0 ) 

      for(let i=0; i<this.max; i++)
        this.$refs['base_'+ i][0].draw()

      this.ctx.restore()

    },

    loop() {
      requestAnimationFrame( this.loop )
      this.step()
      this.draw()
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Circles
  position fixed
  top 0
  width 100vw
  height 100%
  overflow hidden  
  color black
  background #4f518b

  canvas 
    display block
    height 100vh
    border none

  body .dg .c .slider-fg 
    background #666 

  .slider-fg 
    transition width 150ms 

  .slider:active .slider-fg 
    transition-duration 0ms

</style>


